module.exports = __webpack_public_path__ + "static/img/2.26a0206.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/juhua/R410A/2.jpg
// module id = cTA0
// module chunks = 1